

































import { Vue } from "vue-property-decorator";
import axios from "axios";

const getLanguage = (): string => {
  const browserLang = navigator.language.split("-")[0];

  if (
    browserLang == "en" ||
    browserLang == "fr" ||
    browserLang == "nl" ||
    browserLang == "de"
  ) {
    return browserLang;
  }

  return "en";
};

export default Vue.extend({
  name: "Login" as string,
  data() {
    return {
      type: "password",
      logInButtonDisabled: false,
      input: {
        username: "",
        password: "",
        culture: getLanguage()
      },
      dictationAccounts: null,
      errorBorder: "",
      errorMessage: ""
    };
  },
  methods: {
    login() {
      if (this.input.username != "" && this.input.password != "") {
        this.logInButtonDisabled = true;
        axios
          .post(process.env.VUE_APP_API_URL, {
            username: this.input.username,
            password: this.input.password,
            culture: this.input.culture
          })
          .then(res => {
            if (Array.isArray(res.data) && res.data.length === 1) {
              window.location = res.data[0].LoginUrl;
              return;
            }

            this.input.password = "";
            this.$emit("switchToAccountSelector", res.data);
          })
          .catch(err => {
            this.errorBorder = "show";
            this.errorMessage = err.response ? err.response.data : err.message;
            this.input.password = "";
          })
          .finally(() => {
            this.logInButtonDisabled = false;
          });
        return;
      }

      this.errorBorder = "show";
      this.errorMessage = "Please enter email address and Password";
    },
    togglePasswordField() {
      this.type = this.type === "password" ? "text" : "password";
    }
  },
  mounted() {
    axios
      .head(process.env.VUE_APP_API_URL)
      .then(res => {
        // eslint-disable-next-line no-console
        console.log(res);
      })
      .catch(err => {
        this.errorBorder = "show";
        this.errorMessage = err.response ? err.response.data : err.message;
        this.input.password = "";
        // eslint-disable-next-line no-console
        console.log(err.response ? err.response.data : err.message);
      });
    return;
  }
});
